
import { useRouter } from 'vue-router';
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  components: {
    breadcrumb: defineAsyncComponent(() => import('@/components/Breadcrumbs.vue')),
  },
  props: {},
  setup() {
    const router = useRouter();
    return {
      handleClick() {
        router.push('/Teacher/experimentinfo/detail');
      },
    };
  },
});
